import React, { useMemo, useState } from "react";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import MDBox from "components/MDBox";
import helpers from "../AnalyticsHelpers";

import AnalyticsSearch from "./AnalyticsSearch";
import AnalyticsResults from "../analyticsResults/AnalyticsResults";
import AnalyticsComparisonChart from "../analyticsResults/AnalyticsComparisonChart";
import Loading from "../Loading";

function AnalyticsCustomSearchToIndividualApartment({
  dispatch,
  individualApartmentId,
  individualApartmentName,
  projectTimeZone,
  metricsConfig,
  darkMode,
  t,
}) {
  const [charts, setCharts] = useState([]);
  const [comparisonChartIds, setComparisonChartIds] = useState([]);
  const [loading, setLoading] = useState(false);

  // const comparisonCandidate = useMemo(() => {
  //   const grouped = charts.reduce((acc, chart) => {
  //     if (!chart?.queryPeriod) return acc;
  //     if (!Array.isArray(chart?.points) || chart.points.length === 0) return acc;
  //     const key = chart.queryPeriod;
  //     if (!acc[key]) acc[key] = [];
  //     acc[key].push(chart);
  //     return acc;
  //   }, {});

  //   const firstPairGroup = Object.values(grouped).find((group) => group.length >= 2);
  //   if (!firstPairGroup) return null;

  //   const [firstChart, secondChart] = firstPairGroup;
  //   return {
  //     chartIds: [firstChart.id, secondChart.id],
  //     charts: [firstChart, secondChart],
  //     queryPeriod: firstChart.queryPeriod,
  //   };
  // }, [charts]);

  const activeComparisonCharts = useMemo(() => {
    if (!comparisonChartIds.length) return [];
    const selected = charts.filter((chart) => comparisonChartIds.includes(chart?.id));
    if (selected.length !== 2) return [];
    return selected;
  }, [charts, comparisonChartIds]);

  // const handleCompare = () => {
  //   if (!comparisonCandidate) {
  //     setComparisonChartIds([]);
  //     return;
  //   }

  //   setComparisonChartIds(comparisonCandidate.chartIds);
  // };

  const handleSearchSubmit = (payload) => {
    setLoading(true);

    const { measurement, period, field, referenceDate, mode, startDate, endDate } = payload;

    const measurementTitleLabel = helpers.getMetricTitleLabel({
      metricKey: measurement,
      metricsConfig,
      t,
    });

    const referenceDateISO = referenceDate;

    const chartId = `dev-${individualApartmentId}-${t(
      measurement
    )}-${period}-${field}-${Date.now()}`;

    const tz = projectTimeZone || "UTC";

    dispatch({
      type: "MAKE_QUERY",
      payload: {
        source: "dev",
        apartmentId: individualApartmentId,
        flux: helpers.getFluxIndividualApartment(
          period,
          mode,
          startDate,
          endDate,
          referenceDateISO,
          measurement,
          individualApartmentId,
          field,
          tz
        ),
        cb: (res) => {
          const rows = helpers.extractRows(res);

          let points = [];

          points = helpers.rowsToPoints(rows, period, tz, t);

          const title = helpers.buildSingleTitle({
            apartmentLabel: individualApartmentName,
            measurementLabel: measurementTitleLabel,
            period,
            referenceDate,
            timeZone: tz,
            t,
            mode,
            startDate,
            endDate,
          });

          setCharts((prev) => [
            {
              id: chartId,
              title,
              referenceDate,
              points,
              allApartments: false,
              queryPeriod: period,
              measurement,
              field,
            },
            ...prev,
          ]);
          setLoading(false);
        },
      },
    });
  };

  const removeChart = (id) => setCharts((prev) => prev.filter((chart) => chart?.id !== id));

  return (
    <MDBox style={{ padding: 16 }}>
      <AnalyticsSearch
        onSubmit={handleSearchSubmit}
        individualApartmentId={individualApartmentId}
        individualApartmentName={individualApartmentName}
        metricsConfig={metricsConfig}
        loading={loading}
        // showCompareControls={!!comparisonCandidate}
        // compareSummaryText=""
        // compareDisabled={!comparisonCandidate}
        // onCompare={handleCompare}
        darkMode={darkMode}
        t={t}
      />

      {activeComparisonCharts.length === 2 && (
        <AnalyticsComparisonChart
          charts={activeComparisonCharts}
          darkMode={darkMode}
          metricsConfig={metricsConfig}
          projectTimeZone={projectTimeZone}
          queryPeriod={activeComparisonCharts?.[0]?.queryPeriod}
          t={t}
        />
      )}

      <MDBox style={{ display: "flex", flexDirection: "column", gap: 16 }}>
        {loading && <Loading darkMode={darkMode} t={t} />}

        {charts.map((chart) => (
          <AnalyticsResults
            key={chart?.id}
            title={chart?.title}
            points={chart?.points}
            queryPeriod={chart?.queryPeriod}
            allApartments={chart?.allApartments}
            projectTimeZone={projectTimeZone}
            measurement={chart?.measurement}
            field={chart?.field}
            metricsConfig={metricsConfig}
            darkMode={darkMode}
            onRemove={() => {
              if (comparisonChartIds.includes(chart?.id)) {
                setComparisonChartIds([]);
              }
              removeChart(chart?.id);
            }}
            t={t}
          />
        ))}
      </MDBox>
    </MDBox>
  );
}

AnalyticsCustomSearchToIndividualApartment.propTypes = {
  dispatch: PropTypes.func.isRequired,
  individualApartmentId: PropTypes.string,
  individualApartmentName: PropTypes.string,
  projectTimeZone: PropTypes.string,
  metricsConfig: PropTypes.object,
  darkMode: PropTypes.bool,
  t: PropTypes.func,
};

AnalyticsCustomSearchToIndividualApartment.defaultProps = {
  individualApartmentId: "",
  individualApartmentName: "",
  projectTimeZone: "UTC",
  metricsConfig: {},
  darkMode: false,
  t: () => {},
};

export default connect((state, ownProps) => ({
  individualApartmentId: ownProps.individualApartmentId,
  individualApartmentName: ownProps.individualApartmentName,
  projectTimeZone: ownProps.projectTimeZone,
  metricsConfig: ownProps.metricsConfig,
  darkMode: ownProps.darkMode,
  t: ownProps.t,
}))(AnalyticsCustomSearchToIndividualApartment);
